module.exports = __webpack_public_path__ + "static/OpenSans-Regular-9863aaace5fcaf897956737ef26b427f.woff";